<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>



<!--    {{isDataChange}}-->
    <h1>網頁文字</h1>
    <MyCkEditor v-model="datas.HtmlContent" height="600px" width="800px"></MyCkEditor>
    <h2>詳細</h2>

    <ListEditBlock :datas="datas.Items" :is-allow-edit="!isDataChange"></ListEditBlock>
  </div>
</template>

<script>

/**

 **/

import MyCkEditor from "@/views/taylorAdmin/component/MyCkEditor";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";

import {
  QueryType_Content,
} from "./js/rotaryDeclare";
import ListEditBlock from "./component/ListEditBlock";

export default {
  components: {ListEditBlock, MyCkEditor},
  //name: "contentEdit",
  data: function () {
    return {
      SystemId: "",
      isLoaded:false,
      isDataChange:false,
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{},
      datasTemplate:{
        HtmlContent:"",
        Items:[],
      },
      datasDemo:{
        Items:[],
      },
      QueryType_Content:QueryType_Content,
    };
  },
  watch:{
    // datas: function(newValue, oldValue) {
    //   debugger // eslint-disable-line
    //   if (this.isLoaded){
    //     this.isDataChange = true;
    //   }
    // }
    datas:{
      handler(val,oldValue) {
        if (this.isLoaded) {
          this.isDataChange = true;
        }
      },
      deep:true,
    }
  },
  methods: {
    loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
      this.loadDataByQueryType(this.QueryType_Content +"_"+ this.SystemId)

      // debugger // eslint-disable-line
    },
    loadDataByQueryType(queryType) {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;
      apiAdmin.api_getContent(queryType).then((data)=>{
        let dataApi=apiAdmin.initReturnString(data.data.data);

        if (dataApi===""){
          that.datas=that.datasTemplate;
        }else{
          that.datas=dataApi;
        }
        that.$nextTick(() => { //with this we skip the first change
          that.isLoaded = true
        })
      })
    },
    submit(){
      // for (let i = 0; i < this.datas.Details.length; i++) {
      //   let item = this.datas.Details[i];
      //
      //   if (item.Year===""){
      //     util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
      //     return;
      //   }
      // }

      let that=this;
      apiAdmin.api_saveContent(this.QueryType_Content +"_"+ this.SystemId,this.datas).then((data)=>{
        console.log(data);
        that.isDataChange = false;
        alert('儲存成功')
      })
    },
  },
  mounted() {
    this.SystemId=this.$route.query.SystemId
    this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
}
</style>
